<div class="d-flex flex-column gap-1">
  @if (languageAttribute) {
    <app-field-label [attribute]="languageAttribute" [passportId]="passportId"></app-field-label>
  }
  <div class="d-flex gap-2 align-items-center">
    @if (flagPath) {
      <img [src]="flagPath" alt="" aria-hidden="true" width="16" height="16" class="language-row-flag" />
    }
    <ix-select
      [attr.aria-label]="
        'battery_pass.edit.list_language.language_aria_label'
          | translate: {label: label, row: row + 1}
      "
      [value]="selectedLanguageCode"
      (valueChange)="onLanguageRowChange($event)"
      class="w-100"
    >
      @for (code of availableLanguageCodes; track code) {
        <ix-select-item [label]="displayNameFor(code)" value="{{ code }}"></ix-select-item>
      }
    </ix-select>
  </div>
  @if (hasDuplicate) {
    <ix-typography format="label" textColor="alarm">
      {{ 'battery_pass.edit.list_language.duplicate_language_error' | translate }}
    </ix-typography>
  }
</div>

